import Seo from "@/components/Seo";
import PageLayout from "@/components/PageLayout";
import Hero from "@/components/sections/Hero";
import HomeIntro from "@/components/sections/HomeIntro";
import TrustBar from "@/components/sections/TrustBar";
import Services from "@/components/sections/Services";
import WhyCrestline from "@/components/sections/WhyCrestline";
import Process from "@/components/sections/Process";
import Projects from "@/components/sections/Projects";
import Testimonials from "@/components/sections/Testimonials";
import CTABanner from "@/components/sections/CTABanner";
import { canonicalFor } from "@/lib/site";

export default function Home() {
  return (
    <>
      <Seo
        title="Crestline Roofing Ltd. | Vancouver Roofing Experts"
        description="Crestline Roofing Ltd. offers expert roof repair and installation across Vancouver and the Fraser Valley. Licensed, insured, and local. Get your free estimate today."
        canonical={canonicalFor("/")}
      />
      <PageLayout>
        {({ openEstimate }) => (
          <main data-testid="home-page" className="bg-[var(--crest-charcoal)] text-white">
            <Hero onOpenEstimate={openEstimate} />
            <HomeIntro />
            <TrustBar />
            <Services onOpenEstimate={openEstimate} />
            <WhyCrestline />
            <Process />
            <Projects />
            <Testimonials />
            <CTABanner
              onOpenEstimate={openEstimate}
              eyebrow="Don't wait for the next storm"
              heading="Get a Free Estimate."
              subheading="Your roof protects everything. Make sure it's done right."
              buttonLabel="Request Your Free Estimate"
            />
          </main>
        )}
      </PageLayout>
    </>
  );
}
